import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';

export default class BN_Asam4LevelOfCareCriteriaTerminologyCriteria extends BackboneElement {
    static __className = 'BN_Asam4LevelOfCareCriteriaTerminologyCriteria';

    __objectStructure = {
        text: String,
        id: String,
        selectable: Boolean,
        subcriteria: [BN_Asam4LevelOfCareCriteriaTerminologyCriteria],
    };

    constructor(constructJson, className = 'BN_Asam4LevelOfCareCriteriaTerminologyCriteria') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
